module.exports = __webpack_public_path__ + "img/fc-seville.b70495a5.png";